import templateUrl from './member-compliance.html';

export default {
  templateUrl,
  bindings: {
    compliantCompanies: '<',
    nonCompliantCompanies: '<'
  },
  controller: class MemberComplianceComponent {
    constructor() {
      'ngInject';
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/member-compliance/member-compliance.component.js